// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Lp5nn","bigColWidth":"Table_bigColWidth__3ZsFo","biggerColWidth":"Table_biggerColWidth__2DE4a","row":"Table_row__2Rima","col":"Table_col__1sHq1"};